import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LogoutOutlined } from '@ant-design/icons';
import { Icon, Button } from 'antd';
import { getToken } from '../helpers';
import login from '../Actions/login';
import { withRouter } from 'react-router';
import Notification from './Notification';
import UserInfo from './UserInfo';
import ServiceResponseRate from './ServiceResponseRate';
const { logout } = login.actions; 
const token = getToken();

class Header extends Component {
    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
        this.isLogged = this.isLogged.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.buyLicense = this.buyLicense.bind(this);
        this.showEnhancePackage = this.showEnhancePackage.bind(this);
    }

    render() {
        let { logo, userInfo, drive } = this.props;
        const { image } = drive;
        return (
            <header className="header">
                <div className="container inner-header">
                    <figure className="logo cursor" onClick={this.goToIndex}>
                        <img src={logo} alt="Smarter Gestión XML" />
                    </figure>
    
                {   this.isLogged() &&
                    <div style={{display:'flex', alignItems: 'center', height:'100%'}}>
                        {this.showEnhancePackage() &&
                            <Button style={{ marginRight: '25px'}} type="primary" onClick={this.buyLicense}>Mejorar tu Plan</Button>
                        }
                        <ServiceResponseRate />
                        <Notification />
                        <div className="wrapper" style={{ margin:'0 25px 0 15px', borderLeft: '1px solid #EBEDF0', height:'100%', display: 'flex', alignItems: 'center'}}>
                            <UserInfo image={image} data={userInfo}/>
                        </div>                        
                        <span className="log-out" onClick={this.logout}>
                            <LogoutOutlined style={{transform: 'rotate(270deg)'}} />
                            Cerrar sesión
                        </span>
                    </div>
                    
                }
                </div>
            </header>
        );
    }

    logout() {
        this.props.logout();
    }

    showEnhancePackage() {
        const { items } = this.props.licensePagination;
        let foundFreePackage = items.find(item => item.nombrePaquete.toLowerCase() === 'efisco gratuito');
        if(foundFreePackage)
            return true;
        return false;
    }

    isLogged() {
        let { isLogged } = this.props;
        return token !== '' || isLogged;
    }

    goToIndex() {
        if(this.isLogged()) {
            this.props.history.goBack();
        } else {
            this.props.history.push('/');
        }
    }

    buyLicense() {
		this.props.history.push(`/buy-license/user/${this.props.email}`);
	}
}

const mapStateToProps = state => {
	return {
		isLogged: state.login.isLogged,
        licensePagination: state.license.licensePagination,
        userInfo: state.user.userInfo,
        drive: state.googleDrive.data,
        email: Object.keys(state.login.login).length > 0 ? state.login.login.values.username : state.register.registerData.email,
	};
};

const mapDispatchToProps = dispatch => {
    return {
        logout() {
            dispatch(logout());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header)); 